import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getFailedRequisitions } from '../clients/mariapps.api';

export const mariAppsFailedRequisitions = createQueryKeys('mariAppsFailedRequisitions', {
    list: (groupId?: string) => ({
        queryKey: [groupId],
        queryFn: () => getFailedRequisitions(groupId),
    }),
});
